<template>
  <transition
    v-on:enter="enter"
    v-on:after-enter="afterEnter"

    v-on:leave="leave"
    v-on:after-leave="afterLeave"

    :duration="duration"
  >

    <div class="collapse" v-if="open">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      duration: { default: 500, type: Number },
      open: { type: Boolean, default: false }
    },
    mounted () {
    },
    methods: {
      enter (el, done) {
        el.style.transition = `${this.duration/1000}s height`
        const width = getComputedStyle(el).width
        el.style.width = width
        el.style.height = 'auto'
        el.style.position = 'absolute'
        el.style.visibility = 'hidden'

        const height = getComputedStyle(el).height

        el.style.width = null
        el.style.position = null
        el.style.visibility = null
        el.style.height = 0

        setTimeout(() => {
          el.style.height = height
          setTimeout(done, this.duration)
        })
      },
      afterEnter: (el) => (el.style.height = 'auto'),
      leave (el, done) {
        el.style.height = getComputedStyle(el).height;

        setTimeout(() => {
          el.style.height = 0;
          setTimeout(() => {
            done()
          }, this.duration)
        });
      },
      afterLeave () {
      },
    }
  }
</script>

<style lang="scss">
  .collapse {
    overflow: hidden;
  }
</style>
